import React from "react";
import { useForm } from "react-hook-form";
import { Button } from "./ui/button";
import { HookInput } from "../helpers/formHelpers";

const LoginForm = ({ onSubmit }: { onSubmit: any }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // eslint-disable-next-line
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return (
    <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
      <HookInput
        control={control}
        name="email"
        label="Email"
        errors={errors}
        rules={{ required: "Required", pattern: { value: emailRegex, message: "Invalid Email Address" } }}
      />
      <HookInput
        control={control}
        name="password"
        type="password"
        label="Password"
        errors={errors}
        rules={{ required: "Required" }}
      />
      <Button type="submit">Login</Button>
    </form>
  );
};

export default LoginForm;
